<template>
  <div class="radio" :class="disabledClass" :style="{ marginLeft: wrapMarginLeft }">
    <div class="radio-icon" :style="checkboxStyle" @click="changeRadio">
      <span :class="checkIconClass" :style="checkIconStyle"></span>
    </div>
    <span
      v-if="props.label"
      class="label"
      :style="{ marginLeft: labelMarginLeft || '8px' }"
      @click="changeRadio"
    >
      <slot name="default">
        {{ props.label }}
      </slot>
    </span>
  </div>
</template>
<script lang="ts" setup>
import {
  defineEmits,
  computed,
  watch,
  ref,
  withDefaults,
  inject,
  watchEffect,
} from "vue";
import { RADIO_SYMBOL_KEY } from "./cy-radio-group.vue";
import type { ProvideType } from "./cy-radio-group.vue";

const props = withDefaults(
  defineProps<{
    modelValue?: boolean; // 单个使用
    value?: string | number | boolean; // 多个使用
    disabled?: boolean;
    label?: string; // lable 或者label slot
    labelMarginLeft?: string; // 8px
    wrapMarginLeft?: string; // 16px 包容容器外层的margin
    fontSize: string;
    checkColor?: string;
    uncheckColor?: string;
  }>(),
  {
    labelMarginLeft: "8px",
    wrapMarginLeft: "16px",
    fontSize: "13px",
    checkColor: "#000000",
    uncheckColor: "#888888",
  }
);

const emits = defineEmits<{
  (e: "update:model-value", value: any): void;
  (e: "change", value: any): void;
}>();

const injectInfo = inject<ProvideType | null>(RADIO_SYMBOL_KEY, null);

const curValue = ref(false);
const disabledFromGroup = ref(false);

const disabledClass = computed(() => {
  if (disabledFromGroup.value) return "disabled";
  return props.disabled ? "disabled" : "cur-point";
});
const checkIconClass = computed(() => {
  return `iconfont ${
    curValue.value
      ? "icon-xianxing_gouxuancion check"
      : "uncheck icon-a-gouxuan_yuanxingicon"
  }`;
});
const checkboxStyle = computed(() => {
  return {
    width: props.fontSize,
    height: props.fontSize,
  };
});
const checkIconStyle = computed(() => {
  return {
    fontSize: props.fontSize,
    color: curValue.value ? props.checkColor : props.uncheckColor,
  };
});

const changeRadio = () => {
  if (props.disabled) return;
  curValue.value = true;
  emits("update:model-value", true);
  emits("change", true);
  if (injectInfo) {
    injectInfo.setGroupValue(() => props.value);
  }
};
watch(
  () => props.modelValue,
  (newValue) => {
    curValue.value = Boolean(newValue);
  },
  { immediate: true }
);
watchEffect(() => {
  if (!injectInfo) return;
  const newValue = injectInfo?.curValue;
  curValue.value = newValue === props.value!;
  const check = curValue.value;
  emits("update:model-value", check);
  emits("change", check);
  const groupDisabled = injectInfo?.getGroupDisabled();
  disabledFromGroup.value = Boolean(groupDisabled);
});
</script>
<style scoped lang="less">
.radio {
  display: flex;
  align-items: center;
  line-height: 14px;
  margin-left: 8px;
  // margin-bottom: 8px;
}
.label {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 16px;
}

.cur-point {
  cursor: pointer;
}
.disabled {
  cursor: not-allowed;
  .radio-icon {
    color: var(--vt-c-white-soft);
    pointer-events: none;
  }
  .label {
    color: @liner-text-color;
    pointer-events: none;
  }
}
</style>
